module.exports = __webpack_public_path__ + "7179b4dc0ad9582db1fea353328ede57.ttf";